<template>
  <div class="homecare-topic-area">
    <!-- show ventilator table -->
    <template v-if="tableName === 'ventilator'">
      <HomeCareVentilatorPage
        :tableName="tableName"
        :tableTitle="tableTitle"
        :listColumnTable="listColumnTable"
        :dataTabFormatted="dataTabFormatted"
      />
    </template>
    <!-- show insulin table -->
    <template v-else-if="tableName === 'insulin'">
      <HomeCareInsulinPage
        :tableName="tableName"
        :tableTitle="tableTitle"
        :listColumnTable="listColumnTable"
        :dataTabFormatted="dataTabFormatted"
      />
    </template>
    <!-- show others table -->
    <template v-else>
      <HomeCarePage
        :tableName="tableName"
        :tableTitle="tableTitle"
        :listColumnTable="listColumnTable"
        :dataTabFormatted="dataTabFormatted"
      />
    </template>
  </div>
</template>
<script>
import HomeCarePage from './HomeCarePage.vue'
import HomeCareVentilatorPage from './HomeCareVentilatorPage.vue'
import HomeCareInsulinPage from './HomeCareInsulinPage.vue'
export default {
  components: {
    HomeCarePage,
    HomeCareVentilatorPage,
    HomeCareInsulinPage,
  },
  props: [
    'tableName',
    'tableTitle',
    'listColumnTable',
    'dataTabFormatted',
  ],
}
</script>
